import React from "react";
import { Outlet } from "react-router-dom";
import { smallLogo } from "../../assets/images";
import AuthBrandPanel from "./AuthBrandPanel";

/**
 * Chrome for every unauthenticated screen. Replaces the
 * `<div lgss:flex><Register /><Body /></div>` wrapper that was duplicated
 * across all ten auth pages.
 *
 * Layout: the page itself scrolls (no nested scroll container) and the brand
 * panel sticks to the viewport. The form column is `min-h-screen` +
 * `justify-center`, so short forms sit centred and tall ones (SignUp, business
 * profile) simply grow and scroll from the top.
 */
const AuthLayout = () => {
  return (
    <div className="flex min-h-screen w-full font-manrope">
      <AuthBrandPanel />

      <div className="flex w-full justify-center lgss:w-3/5">
        <div className="flex min-h-screen w-full max-w-[760px] flex-col justify-center px-5 py-10 lgss:px-10">
          {/* The brand panel is hidden below lgss, so the mark moves inline. */}
          <img
            src={smallLogo}
            className="mb-8 h-[25px] w-[90px] shrink-0 lgss:hidden"
            alt="Deexoptions"
          />

          {/* Pages pick their own width via <AuthPage width="narrow|wide" />. */}
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
